import React from 'react'
import { reduxForm } from 'redux-form'

import LocationForm from './LocationForm'
import { createValidator, isLocation } from 'utils/validations'
import { analytics } from '@src/services/Analytics'
import { convertGoogleMapsPlaceToAddress } from 'utils/google-maps'

const validate = createValidator({
  location: isLocation
})

const collectAnalytics = (data) => {
  const {
    rooms: bedrooms,
    bathrooms,
    location
  } = data

  const eventData = {
    bedrooms,
    bathrooms,
    colonia: convertGoogleMapsPlaceToAddress(location).neighborhood
  }

  analytics.houseSizeSubmit(eventData)
}

export default function (props) {
  const {
    initialValues,
    onSubmit
  } = props

  const handleSubmit = (data) => {
    collectAnalytics(data)
    onSubmit(data)
  }

  const Form = reduxForm({
    form: 'booking',
    initialValues,
    validate,
    onSubmit: handleSubmit
  })(LocationForm)

  return <Form />
}



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/LocationForm/LocationFormContainer.js